import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Container,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@mui/material';
import {
  Add as AddIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { AssessmentList } from 'Components/assessments/AssessmentList';
import { AssessmentWizard } from 'Components/assessments/AssessmentWizard';
import { useAuthTenant } from 'store/auth';

export const AssessmentsPage = () => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const selectedTenant = useSelector(useAuthTenant);

  const handleOpenWizard = () => {
    setIsWizardOpen(true);
  };

  const handleCloseWizard = () => {
    setIsWizardOpen(false);
  };

  const handleWizardSuccess = () => {
    handleCloseWizard();
  };

  return (
    <Container maxWidth="xl">
      <Box py={4}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
          <Box>
            <Typography variant="h4" gutterBottom>
              Vendor Assessments
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Generate, manage, and review vendor security and privacy assessments
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOpenWizard}
            size="large"
          >
            Generate Assessment
          </Button>
        </Box>

        <AssessmentList tenant={selectedTenant?.slug} />

        <Dialog
          open={isWizardOpen}
          onClose={handleCloseWizard}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Generate New Assessment</Typography>
              <IconButton onClick={handleCloseWizard}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent>
            <AssessmentWizard
              onSuccess={handleWizardSuccess}
              onCancel={handleCloseWizard}
              tenant={selectedTenant?.slug}
            />
          </DialogContent>
        </Dialog>
      </Box>
    </Container>
  );
};
